import { render, staticRenderFns } from "./DatosPersonales.vue?vue&type=template&id=68134b9e&"
import script from "./DatosPersonales.vue?vue&type=script&lang=js&"
export * from "./DatosPersonales.vue?vue&type=script&lang=js&"
import style0 from "./DatosPersonales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports